import axios from "axios";


const BASE_URL = process.env.REACT_APP_API_URL;
export const uploadPdfService = async (
  file,
  message,
  prompt,
  attachmark,
  attachsubject,
  conversationId
) => {

  const formData = new FormData();

  // Files (field name "files", supports multiple)
  if (Array.isArray(file)) {
    file.forEach((f) => formData.append("files", f));
  } else if (file) {
    formData.append("files", file);
  }

  // Optional fields
  if (message) formData.append("message", message);
  if (attachmark) formData.append("attachmark", attachmark);
  if (attachsubject) formData.append("attachsubject", attachsubject);
  formData.append("conversation_id", conversationId ?? "");
const accessToken = localStorage.getItem("access_token");
  // Axios request
  return await axios.post(`${BASE_URL}upsc-analyzer/analyze`, formData, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      Accept: "application/json",
    },
  });
};


export const activateFreeTrialService = async () => {
  const accessToken = localStorage.getItem("access_token");

  return await axios.post(
    `${BASE_URL}freetrial/activate`,
    {},
    {
      headers: {
        Accept: "application/json",
        
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
};

export const expireFreeTrialService = async () => {
  const accessToken = localStorage.getItem("access_token");

  return await axios.post(
    `${BASE_URL}freetrial/expire`,
    {}, // empty body
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
};